export const DEFAULT_TITLE = '收银系统与零售数字化解决方案'

export const pageTitles = {
    webindex: '首页',
    webintroduce: '公司简介',
    webproduct: '丰派云POS',
    webproductauto: '自助收银',
    webproductwx: '微商城',
    webdownload: '下载中心',
    webtimeLine: '发展历程',
    webhelp: '客户支持',
    ticketManagement: '提交工单',
    h5index: '首页',
    h5download: '下载中心',
    h5product: '公司简介',
    h5productauto: '自助收银',
    productwxH5: '微商城',
    h5contactus: '联系我们',
    h5pos: '丰派云POS',
    h5goBei: '智慧零售',
    h5diBei: '订货平台',
    h5support: '客户支持'
}



// WEBPACK FOOTER //
// ./src/i18n/pageTitles.js